<template>
  <div>
    <static-alert v-if="message" :message="message" @on-hide="message=''" />
    <transition mode="out-in">
      <div v-if="loading" class="small text-center text-muted">
        <loading-spinner :small="true" class="me-3" /> refreshing eBay Data...
      </div>

      <div v-else>
        <div class="small text-center text-muted mb-2">
          last import: {{ lastDate.toLocaleString() }}
          <div class="d-inline-block ms-3">
            <input type="datetime-local" v-model="formatDate" class="form-control form-control-sm" >
          </div>
          <button type="button" class="btn btn-sm btn-light ms-2" @click="getEbayTransactions" title="refresh data">
            <i class="bi bi-arrow-clockwise"></i>
          </button>
        </div>

      </div>
    </transition>
  </div>
</template>

<script setup>

import LoadingSpinner from "@/app/components/Utils/LoadingSpinner.vue";

import { ref, defineProps, defineEmits, computed } from 'vue'
import { useStore } from "vuex"
import StaticAlert from "@/app/components/Utils/StaticAlert.vue";

const store = useStore()

const props = defineProps({
  transactionType: {
    type: String,
    required: false,
    default: 'ALL'
  }
})

const emits = defineEmits(['onUpdate'])

const dates = ref('')
const inputs = ref([])
const loading = ref(false)
const message = ref('')
const fdate = new Date()
fdate.setDate((new Date()).getDate() - 1)
//const importDate = ref(fdate)
const formatDate = ref(fdate.toISOString().slice(0, 16))

const lastDate = computed(() => store.state.eshop.ebayCheckDate)

getLastImportDate()

function getLastImportDate() {
  loading.value = true
  store.dispatch("eshop/getLastImportDate")
      .then(() => {
        dates.value = `${ formatDate.value }:00.000Z..`
        loading.value = false
        emits('onUpdate')
        //getEbayTransactions()
      })
      .catch(error => {
        message.value = error.response?.data || error.message || error
        console.log(error)
      })
}

function getEbayTransactions() {
  inputs.value = []
  loading.value = true

  dates.value = `${ formatDate.value }:00.000Z..`

  store.dispatch('eshop/getEbayData', {
    type: props.transactionType || 'ALL',
    dates: dates.value //'2024-09-07T05:00:01.000Z..2024-09-09T05:00:01.000Z'
  })
      .then(() => {
        emits('onUpdate')
        loading.value = false
      })
      .catch(error => {
        loading.value = false
        message.value = error.response?.data || error.message || error
        console.log('getEbayData error', error)
      })
}

</script>
